/**
 * WEB-1694 — оформление ТЕКСТА ВНУТРИ ПОЛЯ ВВОДА отдельно от подписи над ним.
 *
 * Репорт владельца (блок «Почта»): «Можно задать размер только лейблу для
 * input, но тексту внутри самого input размер нельзя задать»; про «Текстовое
 * поле»: «нельзя задать цвет для текста внутри input». Дальше он прошёл
 * подряд ещё пять полей ввода — телефон, дату, число, список, имя — и назвал
 * то же самое.
 *
 * КОРЕНЬ. У самого `<input>`/`<select>` оба свойства зашиты в разметке:
 * `fontSize: 16` числом и `color: 'var(--color-text-on-surface,
 * var(--color-text-primary, inherit))'`. Общее поле «Размер текста внутри
 * элемента» (`innerFontSize`, WEB-1440) ставит кегль на ОБЁРТКУ блока в
 * расчёте на наследование: подпись его наследует (своего размера у неё нет), а
 * поле ввода — нет, размер у него задан явно и потому сильнее. Отсюда ровно то
 * ощущение, которое описал владелец: «лейбл настраивается, а само поле нет».
 * С цветом наоборот: `innerTextColor` подменяет обе переменные сразу и красит
 * подпись И поле ОДНИМ махом — раздельно было нечем.
 *
 * ЧЕТЫРЕ НАСТРОЙКИ, А НЕ ДВЕ. Владелец просил именно разделения: «цвет для
 * лейбла и для текста внутри инпута, и по размерам то же самое». Поэтому пара
 * своих полей заводится и подписи тоже — иначе «независимость» была бы
 * половинчатой: подпись по-прежнему двигалась бы только вместе со всем блоком.
 * Общие `innerTextColor`/`innerFontSize` НЕ трогаются и продолжают работать
 * как раньше — они остаются настройкой «на весь блок», а новые поля сильнее
 * их точечно. Это тот же расклад, что у вариантов ответа (WEB-1672/1673), где
 * `optionTextColor` живёт рядом с `innerTextColor`, а не вместо него.
 *
 * ПОРЯДОК СИЛЫ (шрам WEB-934 про слой-победитель):
 *  1. `inputLabelColor`/`inputLabelFontSize` — подпись, явный выбор автора;
 *  2. `inputTextColor`/`inputTextFontSize` — текст внутри поля, явный выбор;
 *  3. всё, что решало вид до этой карточки: переменные поверхности блока
 *     (`--color-text-on-surface`/`--color-text-primary`, куда пишет
 *     `innerTextColor`), унаследованный от обёртки кегль и зашитые 16px.
 *
 * Слой автора отдаётся НАКЛАДКОЙ (`{ color }` / `{ fontSize }` либо ПУСТОЙ
 * объект), которую рендер спредит ПОСЛЕ прежних строк — а не обёрткой вокруг
 * них. Два следствия, оба намеренные:
 *  • при пустом поле спредится `{}`, то есть у старой воронки не меняется ни
 *    пиксель, ни байт inline-стиля (⛔ распоряжение владельца 24.08 «живые
 *    воронки не трогаем»);
 *  • прежние строки остаются в исходнике дословно — их стерегут регресс-тесты
 *    WEB-688c/WEB-775 (цвет маски даты и выбранного пункта списка), и
 *    переписывать их под эту правку нельзя.
 *
 * ПОДСКАЗКА ВНУТРИ ПОЛЯ (placeholder) — РЕШЕНО: остаётся приглушённой и
 * авторский цвет НЕ наследует. Подсказка — это пример, а не ответ посетителя;
 * покрасив её тем же цветом, что и набранный текст, их станет не различить, и
 * поле начнёт выглядеть заполненным, когда оно пусто. Размер она получает —
 * иначе накладка-подсказка поля даты разъедется с самим полем.
 *
 * Кто исполняет это правило, по типам поля (возврат приёмки 25.08 — у списка
 * оно НЕ исполнялось, подсказка «Select…» красилась авторским цветом):
 *  • пять текстовых полей — сам браузер: `::placeholder` несёт свою UA-краску,
 *    и инлайновый `color` элемента её не трогает;
 *  • поле даты — собственная накладка-подсказка: пока значения нет, ветка не
 *    спредит накладку цвета вовсе (нативная маска в этом состоянии спрятана);
 *  • выпадающий список — та же ветка-условие, что у даты: подсказка у него это
 *    пустой `<option>`, который рисуется цветом САМОГО `<select>`, отдельного
 *    механизма приглушения у него нет. Пока значение не выбрано, накладка
 *    цвета не спредится; выбрали — красит, как и раньше.
 *
 * ВЫПАДАЮЩИЙ СПИСОК — РЕШЕНО ЧЕСТНО: настройки применяются к САМОМУ элементу
 * `<select>`, то есть к видимому выбранному значению. Раскрытый перечень
 * вариантов рисует операционная система, и оформление отдельных `<option>`
 * большинство браузеров (Safari, Chrome под macOS/iOS) игнорирует — обещать
 * это в панели нельзя, поэтому и не обещаем.
 *
 * Список типов — ЗЕРКАЛО канона бэка (backend/src/ai-funnels/block-schema/
 * input-field-style.ts, INPUT_FIELD_BLOCK_TYPES): он же решает, каким блокам
 * панель показывает четыре поля. Разъезд ловит сторож
 * input-field-style.web1694.spec.ts (читает ЭТОТ файл с диска) — не
 * переименовывать и не менять форму `new Set([...])` не обновив его.
 *
 * Почему ровно семь типов. Перебором обоих файлов рендера: это все ветки, где
 * посетитель ВВОДИТ или ВЫБИРАЕТ значение в текстовом поле — `<input>` с
 * подписью-`<label>` из `block.content` либо `<select>` того же устройства.
 * Намеренно НЕ здесь:
 *  • `checkbox`/`terms_checkbox`/`toggle`/`single_choice`/`multiple_choice`/
 *    `multi_step_question`/`plan_selector` — там нативный input есть, но он
 *    отметка (галочка/радио) без собственного текста; его цвет — своё поле
 *    «Цвет отметки» (`optionAccentColor`, WEB-1651-3), а подписи вариантов —
 *    свои поля (WEB-1672/1673);
 *  • `slider_range`, `photo_upload`, `scratch_card` и прочие служебные
 *    `<input>` — там поле не показывает текст вовсе (ползунок, файл, скрытое
 *    значение), настройка была бы мёртвой (ловушка WEB-1496 п.4).
 */

// Слово владельца 21.10.2026: правила `::placeholder` и `:focus` для своего
// цвета подсказки и рамки в фокусе (inline-стилем их не задать). Файл
// импортируется ЗДЕСЬ — его берёт каждая отрисовка поля ввода (публичная
// воронка и превью редактора), значит правило едет туда же, куда накладка.
import './inputFieldLook.css';

/**
 * Блоки, где посетитель вводит текст в поле с подписью над ним. Слово
 * владельца 21.10.2026: плюс выбор веса и роста — то же поле числа, что у
 * `number_input` (UnitPickerRenderer.tsx), кнопки единиц сюда не входят.
 */
export const INPUT_FIELD_BLOCK_TYPES: ReadonlySet<string> = new Set([
  'date_picker',
  'email',
  'name_field',
  'number_input',
  'phone_input',
  'select_dropdown',
  'text_field',
  'weight_picker',
  'height_picker',
]);

/** Поля оформления полей ввода, читаемые обоими рендерерами. */
export interface InputFieldStyleFields {
  /** Цвет ПОДПИСИ над полем. Absent/пусто = как раньше (цвет темы блока). */
  inputLabelColor?: string;
  /** Кегль ПОДПИСИ над полем, px. Absent = как раньше (наследуется от блока). */
  inputLabelFontSize?: number;
  /** Цвет текста ВНУТРИ поля. Absent/пусто = как раньше (переменные темы). */
  inputTextColor?: string;
  /** Кегль текста ВНУТРИ поля, px. Absent = как раньше (зашитые 16px). */
  inputTextFontSize?: number;
  // Слово владельца 21.10.2026 — вид САМОГО поля. Absent у каждого = как
  // раньше (решает стиль-пак). Границы — INPUT_FIELD_LOOK_BOUNDS ниже.
  /** Фон поля. */
  inputBackgroundColor?: string;
  /** Цвет рамки поля. */
  inputBorderColor?: string;
  /** Толщина рамки, px. */
  inputBorderWidth?: number;
  /** Скругление углов, px. */
  inputBorderRadius?: number;
  /** Высота поля, px. */
  inputHeight?: number;
  /** Отступ слева и справа внутри поля, px. */
  inputPaddingX?: number;
  /** Цвет тени; без него тень не рисуется. */
  inputShadowColor?: string;
  /** Непрозрачность тени, 0..1. */
  inputShadowOpacity?: number;
  /** Размытие тени, px. */
  inputShadowBlur?: number;
  /** Сдвиг тени вниз (минус — вверх), px. */
  inputShadowOffsetY?: number;
  /** Цвет подсказки внутри пустого поля. */
  inputPlaceholderColor?: string;
  /** Цвет рамки, пока поле в фокусе. */
  inputFocusBorderColor?: string;
}

function trimmed(value?: string): string | undefined {
  return value?.trim() || undefined;
}

/**
 * Накладка на ПОДПИСЬ над полем: цвет и кегль вместе — у подписи, в отличие от
 * самого поля, условных состояний нет, поэтому дробить накладку незачем.
 * Спредится ПОСЛЕ прежних стилей `<label>`.
 */
export function inputLabelStyleOverride(fields: InputFieldStyleFields): {
  color?: string;
  fontSize?: number;
} {
  const style: { color?: string; fontSize?: number } = {};
  const color = trimmed(fields.inputLabelColor);
  if (color) style.color = color;
  if (typeof fields.inputLabelFontSize === 'number') {
    style.fontSize = fields.inputLabelFontSize;
  }
  return style;
}

/**
 * Накладка ЦВЕТА текста внутри поля — отдельно от кегля НАМЕРЕННО.
 *
 * У поля даты цвет условный: пока значения нет и видна собственная
 * подсказка-накладка, нативная маска `dd.mm.yyyy` прячется `transparent`
 * (WEB-688 QA — иначе две подсказки сливаются в кашу). Авторский цвет
 * относится к НАБРАННОМУ значению и не имеет права отыграть это назад,
 * поэтому в том состоянии ветка даты накладку цвета не спредит вовсе — а
 * кегль спредит, иначе накладка разъедется с полем. Одна общая накладка такого
 * разделения не позволила бы.
 */
export function inputTextColorOverride(fields: InputFieldStyleFields): {
  color?: string;
} {
  const color = trimmed(fields.inputTextColor);
  return color ? { color } : {};
}

/**
 * Накладка КЕГЛЯ текста внутри поля. Прежний зашитый `fontSize: 16` остаётся в
 * исходнике: пустое поле спредит `{}` и размер прежний до байта.
 */
export function inputTextFontSizeOverride(fields: InputFieldStyleFields): {
  fontSize?: number;
} {
  return typeof fields.inputTextFontSize === 'number'
    ? { fontSize: fields.inputTextFontSize }
    : {};
}

/**
 * Слово владельца 21.10.2026 (снимок Calm) — ВНЕШНИЙ ВИД САМОГО ПОЛЯ.
 *
 * Границы ползунков — ЗЕРКАЛО канона сервера `INPUT_FIELD_LOOK_BOUNDS`
 * (backend/src/ai-funnels/block-schema/input-field-style.ts); разъезд ловит
 * сторож `input-field-style.look-ends.spec.ts` — он читает ЭТОТ объект с
 * диска, форму `{ min: N, max: N }` не менять, не обновив его.
 */
export const INPUT_FIELD_LOOK_BOUNDS = {
  inputBorderWidth: { min: 0, max: 8 },
  inputBorderRadius: { min: 0, max: 40 },
  inputHeight: { min: 32, max: 96 },
  inputPaddingX: { min: 0, max: 48 },
  inputShadowOpacity: { min: 0, max: 1 },
  inputShadowBlur: { min: 0, max: 48 },
  inputShadowOffsetY: { min: -24, max: 24 },
} as const;

/**
 * Что берёт за ползунок тени, которого автор не трогал, когда цвет тени
 * задан. Те же числа панель показывает на нетронутых ползунках — обещание
 * панели и вид совпадают (шрам WEB-1829 п.(а)). Мягкая тень, как у строки
 * варианта (OPTION_SHADOW_DEFAULTS).
 */
export const INPUT_SHADOW_DEFAULTS = {
  blur: 12,
  offsetY: 4,
  opacity: 0.15,
} as const;

/**
 * Прежние зашитые числа поля — то, что накладка берёт за нетронутую
 * половину рамки или отступа (отступ слева и справа без своего поля в
 * накладку не попадает вовсе). Сами строки в разметке не трогаются.
 */
const PACK_BORDER_WIDTH = 2;
const PACK_BORDER_COLOR = 'var(--color-border-primary, #d9d9d9)';
const PACK_PADDING_Y = 10;

/** Класс, на который inputFieldLook.css вешает свой цвет `::placeholder`. */
export const INPUT_PLACEHOLDER_CLASS = 'w2a-input-ph';
/** Класс, на который inputFieldLook.css вешает свой цвет рамки в `:focus`. */
export const INPUT_FOCUS_CLASS = 'w2a-input-focus';

/** Разбор строгого кода цвета (#rgb/#rgba/#rrggbb/#rrggbbaa); иное — null. */
function parseHex(
  hex: string | undefined,
): { r: number; g: number; b: number; a: number } | null {
  const raw = hex?.trim().toLowerCase();
  if (!raw || !/^#([0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/.test(raw)) {
    return null;
  }
  const body = raw.slice(1);
  const full =
    body.length <= 4
      ? body
          .split('')
          .map((c) => c + c)
          .join('')
      : body;
  const byte = (i: number) => parseInt(full.slice(i, i + 2), 16);
  return {
    r: byte(0),
    g: byte(2),
    b: byte(4),
    a: full.length === 8 ? byte(6) / 255 : 1,
  };
}

/** Число в границах; не число — undefined (поле «как в стиле»). */
function within(
  value: number | undefined,
  bounds: { min: number; max: number },
): number | undefined {
  if (typeof value !== 'number' || !Number.isFinite(value)) return undefined;
  return Math.min(bounds.max, Math.max(bounds.min, value));
}

/** CSS-значение тени поля; без годного цвета тени нет (решение задания). */
function inputShadowValue(fields: InputFieldStyleFields): string | undefined {
  const color = parseHex(fields.inputShadowColor);
  if (!color) return undefined;
  const b = INPUT_FIELD_LOOK_BOUNDS;
  const d = INPUT_SHADOW_DEFAULTS;
  const blur = within(fields.inputShadowBlur, b.inputShadowBlur) ?? d.blur;
  const y =
    within(fields.inputShadowOffsetY, b.inputShadowOffsetY) ?? d.offsetY;
  const opacity =
    within(fields.inputShadowOpacity, b.inputShadowOpacity) ?? d.opacity;
  const alpha = Math.round(color.a * opacity * 1000) / 1000;
  return `0px ${y}px ${blur}px rgba(${color.r}, ${color.g}, ${color.b}, ${alpha})`;
}

/** Накладка вида самого поля; ключи — те же, что у прежних строк поля. */
export type InputBoxStyle = {
  background?: string;
  border?: string;
  borderRadius?: number;
  height?: number;
  padding?: string;
  boxShadow?: string;
  '--w2a-input-placeholder'?: string;
  '--w2a-input-focus-border'?: string;
};

/**
 * Накладка вида САМОГО поля — спредится ПОСЛЕ прежних зашитых строк
 * (`padding`, `border`, `borderRadius`, `background`). Ключи накладки те же,
 * что у прежних строк (`border` целиком, `padding` целиком), а не их
 * частные половины: иначе React смешал бы сокращённое и полное свойство в
 * одном стиле. Нетронутая половина берёт прежнее число поля (рамка 2 px
 * цвета пака, отступ сверху 10). Пусто — `{}`, вид прежний до байта.
 *
 * Цвет подсказки и рамки в фокусе inline-стилем не задать (`::placeholder`,
 * `:focus`) — накладка кладёт их переменными на само поле, а правила
 * inputFieldLook.css берут их по классу из `inputLookClassName`.
 */
export function inputBoxStyleOverride(
  fields: InputFieldStyleFields,
): InputBoxStyle {
  const b = INPUT_FIELD_LOOK_BOUNDS;
  const style: InputBoxStyle = {};
  const background = trimmed(fields.inputBackgroundColor);
  if (background) style.background = background;
  const borderColor = trimmed(fields.inputBorderColor);
  const borderWidth = within(fields.inputBorderWidth, b.inputBorderWidth);
  if (borderColor || borderWidth !== undefined) {
    style.border = `${borderWidth ?? PACK_BORDER_WIDTH}px solid ${
      borderColor ?? PACK_BORDER_COLOR
    }`;
  }
  const radius = within(fields.inputBorderRadius, b.inputBorderRadius);
  if (radius !== undefined) style.borderRadius = radius;
  const height = within(fields.inputHeight, b.inputHeight);
  if (height !== undefined) style.height = height;
  const paddingX = within(fields.inputPaddingX, b.inputPaddingX);
  if (paddingX !== undefined)
    style.padding = `${PACK_PADDING_Y}px ${paddingX}px`;
  const shadow = inputShadowValue(fields);
  if (shadow) style.boxShadow = shadow;
  const placeholder = trimmed(fields.inputPlaceholderColor);
  if (placeholder) style['--w2a-input-placeholder'] = placeholder;
  const focus = trimmed(fields.inputFocusBorderColor);
  if (focus) style['--w2a-input-focus-border'] = focus;
  return style;
}

/**
 * Классы поля для правил inputFieldLook.css: свой цвет подсказки и свой
 * цвет рамки в фокусе. Нет ни одного — undefined (атрибута class нет вовсе,
 * разметка старой воронки прежняя).
 */
export function inputLookClassName(
  fields: InputFieldStyleFields,
): string | undefined {
  const names: string[] = [];
  if (trimmed(fields.inputPlaceholderColor))
    names.push(INPUT_PLACEHOLDER_CLASS);
  if (trimmed(fields.inputFocusBorderColor)) names.push(INPUT_FOCUS_CLASS);
  return names.length ? names.join(' ') : undefined;
}

/**
 * Накладка на СОБСТВЕННУЮ подсказку поля даты (у `type="date"` атрибут
 * placeholder браузер не показывает, подсказку рисует накладка-span). Свой
 * цвет автора — без прежнего приглушения 0.6: автор выбрал цвет подсказки
 * сам, и он должен быть ровно таким. Свой отступ поля — и у накладки, иначе
 * она встанет не по месту.
 */
export function inputPlaceholderOverlayOverride(
  fields: InputFieldStyleFields,
): {
  color?: string;
  opacity?: number;
  left?: number;
} {
  const style: { color?: string; opacity?: number; left?: number } = {};
  const color = trimmed(fields.inputPlaceholderColor);
  if (color) {
    style.color = color;
    style.opacity = 1;
  }
  const paddingX = within(
    fields.inputPaddingX,
    INPUT_FIELD_LOOK_BOUNDS.inputPaddingX,
  );
  if (paddingX !== undefined) style.left = paddingX;
  return style;
}

/**
 * Цвет подсказки выпадающего списка: его подсказка — пустой `<option>`,
 * который рисуется цветом самого `<select>`. Пока ответ не выбран, select
 * красится цветом подсказки автора; выбрали — цветом текста (как раньше).
 */
export function inputPlaceholderColorOverride(fields: InputFieldStyleFields): {
  color?: string;
} {
  const color = trimmed(fields.inputPlaceholderColor);
  return color ? { color } : {};
}
